var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgPersonalMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38.0968L46 0L92 38.0968V92H0V38.0968Z",
    fill: "#BF9976"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9861 70.3859H15.0139C14.55 70.3859 14.1739 70.0104 14.1739 69.5468V8.67815C14.1739 8.21526 14.55 7.83972 15.0139 7.83972H76.9861C77.45 7.83972 77.8261 8.21526 77.8261 8.67815V69.5468C77.8261 70.0104 77.45 70.3859 76.9861 70.3859Z",
    fill: "#D6E8F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 40,
    width: 48,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 47,
    width: 48,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 54,
    width: 48,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 19,
    width: 26,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 26,
    width: 16,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7303 15.8585H22.2044V32.36H38.7303V15.8585Z",
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 38.0968L38.1465 65.0487L0 92V38.0968Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 38.0968L53.8535 65.0487L92 92V38.0968Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8854 65.0488H38.1465V65.026L0 92H92L53.8854 65.0488Z",
    fill: "#D7AE88"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPersonalMail);
export default __webpack_public_path__ + "static/media/imgPersonalMail.6f27f82ffccee9d0362a4572d545ec1c.svg";
export { ForwardRef as ReactComponent };